import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
@Injectable({
  providedIn: 'root',
  
  
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    /**
    *get user object from local storage
    *@param {object} validator will be true if object find else validator will be false
    */
    let obj = JSON.parse(localStorage.getItem("userToken"));
    let validator = false;
    obj ? (validator = true) : this.router.navigate(['/'])
    return validator;
  }
}
